import { css } from "emotion"

export const mapClass = css`
  min-height: calc(100vh - 121px);
  width: 100%;
`
